export class PropertyInfoResultDto {
  ownerName: string;
  ownerType: string;
  isCompanyOwner: boolean;
  address: string;
  phase: string;
  section: string;
  block: string;
  lot: string;

  message: string;
  status: string;

  checkDigit: string;
  communityCode: string;
  building: string;
  unit: string;
}
